import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const OpenSourceWork = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      mirror: false,
      easing: 'ease-out-cubic'
    });
    
    return () => {
      AOS.refresh();
    };
  }, []);

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-800 mb-6">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-blue-600">Risk Consulting</span> Services
          </h2>
          <p className="text-gray-700 text-lg max-w-3xl mx-auto leading-relaxed">
            At Fepsec, we provide comprehensive security and risk management solutions to protect your organization's most valuable assets.
            Our team of expert consultants delivers tailored strategies across physical, electronic, cyber, and information security domains.
          </p>
        </div>
        
        <div className="bg-white p-8 md:p-10 rounded-xl shadow-xl mb-16 transform transition-all duration-500 hover:shadow-2xl" data-aos="zoom-in-up">
          <div className="flex flex-col items-center mb-6">
            <div className="bg-gradient-to-r from-blue-600 to-teal-500 rounded-lg p-3 mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h3 className="text-3xl font-bold text-gray-800 mb-3">Risk Consulting Services</h3>
            <p className="text-gray-700 text-lg leading-relaxed text-center max-w-3xl mb-8">
              Comprehensive security and risk management solutions to protect your organization's assets, information, and people. 
              Our expert consultants identify vulnerabilities and implement tailored strategies to mitigate risks and ensure compliance.
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <div className="relative group">
              <Link to="/physical-security" className="flex items-center space-x-2 bg-gradient-to-r from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-200 px-6 py-4 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-blue-200/50">
                <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg p-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <span className="font-medium text-gray-800">Physical Security</span>
              </Link>
            </div>

            <div className="relative group">
              <Link to="/electronics-security" className="flex items-center space-x-2 bg-gradient-to-r from-indigo-50 to-indigo-100 hover:from-indigo-100 hover:to-indigo-200 px-6 py-4 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-indigo-200/50">
                <div className="bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-lg p-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                  </svg>
                </div>
                <span className="font-medium text-gray-800">Electronics Security</span>
              </Link>
            </div>

            <div className="relative group">
              <Link to="/fire-life-safety" className="flex items-center space-x-2 bg-gradient-to-r from-red-50 to-red-100 hover:from-red-100 hover:to-red-200 px-6 py-4 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-red-200/50">
                <div className="bg-gradient-to-br from-red-500 to-red-600 rounded-lg p-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
                  </svg>
                </div>
                <span className="font-medium text-gray-800">Fire Life Safety</span>
              </Link>
            </div>

            <div className="relative group">
              <Link to="/information-security" className="flex items-center space-x-2 bg-gradient-to-r from-purple-50 to-purple-100 hover:from-purple-100 hover:to-purple-200 px-6 py-4 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-purple-200/50">
                <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg p-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
                  </svg>
                </div>
                <span className="font-medium text-gray-800">Information Security</span>
              </Link>
            </div>

            <div className="relative group">
              <Link to="/cyber-security" className="flex items-center space-x-2 bg-gradient-to-r from-teal-50 to-teal-100 hover:from-teal-100 hover:to-teal-200 px-6 py-4 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-teal-200/50">
                <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg p-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </div>
                <span className="font-medium text-gray-800">Cyber Security</span>
              </Link>
            </div>
          </div>
          
          <div className="text-center">
            <Link 
              to="/risk-consulting" 
              className="inline-block bg-gradient-to-r from-blue-600 to-teal-500 text-white font-bold px-8 py-4 rounded-lg shadow-lg transition transform hover:translate-y-[-2px] hover:shadow-xl"
            >
              <div className="flex items-center">
                <span>Learn More About Our Security Solutions</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </div>
            </Link>
          </div>
        </div>
        
        <div className="text-center" data-aos="fade-up">
          <div className="bg-gradient-to-r from-indigo-600 to-blue-600 p-1 rounded-lg inline-block shadow-lg">
            <Link 
              to="/open-source" 
              className="inline-block bg-white hover:bg-gray-50 text-gray-800 font-bold px-8 py-4 rounded-lg transition transform hover:scale-[1.03]"
            >
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-blue-600">
                Explore All Projects
              </span>
            </Link>
          </div>
          
          <a 
            href="https://github.com/fepsec/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-gray-800 hover:bg-gray-700 text-white font-bold px-8 py-4 rounded-lg ml-4 shadow-lg transition transform hover:scale-[1.03]"
          >
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
              </svg>
              GitHub
            </div>
          </a>
        </div>

        <div className="mt-12 bg-gradient-to-r from-blue-900 via-indigo-800 to-blue-900 text-white rounded-2xl overflow-hidden shadow-2xl">
          <div className="bg-pattern-dots bg-opacity-10 p-10 md:p-16">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">Open Source Community</h2>
              <p className="text-white/90 text-lg max-w-3xl mx-auto mb-10 leading-relaxed" data-aos="fade-up" data-aos-delay="300">
                Everyone is welcome in open source. Whether you want to explore, share ideas, or help build something new, your participation matters. Join a global community where collaboration, learning, and creativity drive progress for all. Be part of the movement—open source is yours to shape!
              </p>
              
              <div className="flex justify-center" data-aos="fade-up" data-aos-delay="400">
                <a 
                  href="https://opensource.guide/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-bold px-8 py-4 rounded-xl transition-all duration-300 transform hover:scale-105 border border-white/30 shadow-lg"
                >
                  Learn More About Open Source
                </a>
                
                <Link 
                  to="/contact-us" 
                  className="inline-flex items-center bg-white text-indigo-600 hover:text-blue-600 font-bold px-8 py-4 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg"
                >
                  <svg className="w-6 h-6 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                  Contact Our Team
                </Link>
                
                <Link 
                  to="/kubernetes-consulting" 
                  className="inline-flex items-center bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-bold px-8 py-4 rounded-xl transition-all duration-300 transform hover:scale-105 border border-white/30 shadow-lg"
                >
                  <svg className="w-6 h-6 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                  </svg>
                  Kubernetes Consulting
                </Link>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8" data-aos="fade-up" data-aos-delay="500">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="md:w-3/5">
                <h3 className="text-2xl font-bold text-gray-800 mb-3">Ready to start contributing?</h3>
                <p className="text-gray-700 leading-relaxed">
                  Check out our GitHub repositories and find issues labeled "good first issue" to get started. 
                  We provide guidance and mentorship to help new contributors make their first pull request.
                </p>
              </div>
              
              <a 
                href="https://github.com/fepsec/issues?q=is%3Aissue+is%3Aopen+label%3A%22good+first+issue%22" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center bg-gradient-to-r from-blue-600 to-indigo-600 text-white hover:from-indigo-600 hover:to-blue-600 font-bold px-6 py-3 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-md"
              >
                <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                Find Good First Issues
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpenSourceWork;
